export const convertFileToBase64Native = (fileUri, callback) => {

    if (window.device) {
        window.resolveLocalFileSystemURL(fileUri, (fileEntry) => {
            fileEntry.file((file) => {
                const reader = new FileReader();
                reader.onloadend = () => {

                    const base64Data = reader.result;
                    console.log("Base64 image data:", base64Data);

                    callback(base64Data);
                };
                reader.readAsDataURL(file);
            }, (error) => {
                console.log("Error reading the file:", error.code);
                callback(false);
            });
        }, (error) => {
            console.log("Error resolving file URI:", error.code);
            callback(false);
        });
    } else {
        callback(fileUri);
    }
};